const buttonTextStyles = theme => ({
    loader: { color: theme.palette.common.white },
    loadingText: { paddingLeft: 10 },
});

export default buttonTextStyles;
